<template id="main-page">
</template>

<script>
export default {
created() {
    this.$router.push("/consultaOrcamento")
    window.location.reload()
},
}
</script>